import React, { useRef, useEffect, useState, useCallback } from 'react';
import styled from 'styled-components';
import { Breadcrumb as AntBreadcrumb, Select } from 'antd'
import * as _ from 'lodash';

const Breadcrumb = ({ paths, disableLink }) => {

  const [overflowPaths, setOverflowPaths] = useState([]);
  const [breadcrumbPaths, setBreadcrumbPaths] = useState([]);
  const [widths, setWidths] = useState({})

  const breadcrumbRef = useRef(null);
  const { Option } = Select;
  
  const insert = (arr, index, ...newItems) => [
    ...arr.slice(0, index),
    ...newItems,
    ...arr.slice(index)
  ]

  const onResize = () => {

    if(breadcrumbRef.current) {
      const visibleWidth = breadcrumbRef.current.getBoundingClientRect().width;
      const breadcrumbWidth = breadcrumbRef.current.children[0].offsetWidth;

      if (breadcrumbWidth > 0 && breadcrumbRef.current.children[0].children.length > 1) {
        setWidths({ visibleWidth, breadcrumbWidth });
      }
    }
  }

  function itemRender(route, params, routes, paths) {

    const last = routes.indexOf(route) === routes.length - 1;
    
    if(last || disableLink) {
      if(route.routeCollection) {
        return (
          <Select defaultValue="">
            {route.routeCollection.map((r, i) => (
              <Option key={i} value={r.path}>{r.name}</Option>
            ))}
          </Select>
        )
      }
      else {
        return <span>{route.breadcrumbName}</span>
      }
     }
     else {
       return <a href={route.path}>{route.breadcrumbName}</a>
     }
  }

  // handle window resize
  useEffect(() => {

    const { visibleWidth, breadcrumbWidth } = widths;

    if (visibleWidth > breadcrumbWidth) {

      setOverflowPaths(prevOverflowPaths => {
        
        if (prevOverflowPaths.length === 0) return [];

        let i = 0;
        let addedPaths = [];
        let newBreadcrumbWidth = breadcrumbWidth;

        do {

          // remove overflowPath and save element width
          let addedPath = prevOverflowPaths[i];

          // add width to breadcrumb length
          newBreadcrumbWidth += addedPath.width;

          // make sure we're not adding too much size with the new element
          if (newBreadcrumbWidth > visibleWidth - 25) break;

          //delete removedPath.width;

          addedPaths.push(addedPath)

          i++;

        } while (newBreadcrumbWidth < visibleWidth && i < prevOverflowPaths.length)

        // add path to array
        const newOverflowPaths = _.filter(prevOverflowPaths, o => { return !_.includes(_.map(addedPaths, 'path'), o.path) });
        
        setBreadcrumbPaths(prevBreadcrumbPaths => {

          if (addedPaths.length === 0) return prevBreadcrumbPaths;

          // copy breadcrumbs
          let breadcrumbCopy = _.cloneDeep(prevBreadcrumbPaths);
          delete breadcrumbCopy[breadcrumbCopy.length - 2].children;
          
          if (newOverflowPaths.length > 0) {
            breadcrumbCopy.splice(prevBreadcrumbPaths.length - 1, 0, ...addedPaths)
            breadcrumbCopy[breadcrumbCopy.length - 2].children = [...newOverflowPaths];

            return breadcrumbCopy;
          }
          else {
            return insert(breadcrumbCopy, breadcrumbCopy.length - 1, ...addedPaths);
          }
        })

        if (addedPaths.length === 0) return prevOverflowPaths;

        return newOverflowPaths;
      })
    }

    if (visibleWidth - 25 < breadcrumbWidth) {

      setBreadcrumbPaths(prevBreadcrumbPaths => {

        let i = 1;
        let removedPaths = [];
        let newBreadcrumbWidth = breadcrumbWidth;

        do {

          // get width of the element we're removing
          const elementWidth = breadcrumbRef.current.children[0].children[breadcrumbRef.current.children[0].children.length - i].getBoundingClientRect().width;

          newBreadcrumbWidth -= elementWidth;

          // create overflowPath and save element width
          let removedPath = { width: elementWidth, ...prevBreadcrumbPaths[prevBreadcrumbPaths.length - 1 - i] }
          delete removedPath.children;

          removedPaths.unshift(removedPath);

          i++;

        } while (visibleWidth - 25 < newBreadcrumbWidth)

        // remove paths from array
        let pathsCopy = _.filter(prevBreadcrumbPaths, o => { return !_.includes(_.map(removedPaths, 'path'), o.path) });

        setOverflowPaths(prevPaths => {
          
          const newOverflowPaths = [...removedPaths, ...prevPaths];
          pathsCopy[pathsCopy.length - 2].children = [...newOverflowPaths];

          return newOverflowPaths;
        });

        return pathsCopy;
      })
    }
  }, [widths])

  useEffect(() => {
    if(paths) {
      setOverflowPaths([]);
      setBreadcrumbPaths(_.cloneDeep(paths));

      setTimeout(() => {
        onResize();
      })
    }
  }, [paths])

  useEffect(() => {
    window.addEventListener('resize', _.debounce(onResize, 150));
    return () => window.removeEventListener('resize', _.debounce(onResize, 150));
  }, [])

  return (
    <BreadcrumbContainer ref={breadcrumbRef}>
      <AntBreadcrumb style={{display: 'inline-block', fontSize: '16px'}} routes={breadcrumbPaths} itemRender={itemRender} />
    </BreadcrumbContainer>
  )
}

const BreadcrumbContainer = styled.div`
  height: 50px;
  width: 100%;
  padding: 0 10px;
  line-height: 50px;
  white-space: nowrap;
  background-color: #fff;
  border-bottom: 1px solid #dee0e3;
  user-select: none;
`

export default React.memo(Breadcrumb);